var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgZetaWatermarkRoom = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#zeta_watermark_room_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 19,
    x: 0.5,
    y: 1.312,
    stroke: "#fff",
    strokeOpacity: 0.16,
    rx: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    d: "M8.999 13.912h3.228v.9H7.75v-.9l3.192-4.788H7.775v-.888h4.428v.888l-3.204 4.788Zm10.344-2.64c0 .208-.012.428-.035.66h-5.256c.04.648.26 1.156.66 1.524.408.36.9.54 1.476.54.472 0 .864-.108 1.175-.324.32-.224.544-.52.672-.888h1.177a2.856 2.856 0 0 1-1.056 1.548c-.528.392-1.184.588-1.968.588-.624 0-1.184-.14-1.68-.42a2.995 2.995 0 0 1-1.152-1.188c-.28-.52-.42-1.12-.42-1.8 0-.68.136-1.276.408-1.788a2.836 2.836 0 0 1 1.14-1.176c.495-.28 1.063-.42 1.704-.42.624 0 1.175.136 1.656.408.48.272.848.648 1.104 1.128.264.472.395 1.008.395 1.608Zm-1.128-.228c0-.416-.091-.772-.276-1.068a1.737 1.737 0 0 0-.756-.684c-.311-.16-.66-.24-1.043-.24-.553 0-1.024.176-1.417.528-.384.352-.604.84-.66 1.464h4.152Zm3.602-1.908v3.876c0 .32.068.548.204.684.136.128.372.192.708.192h.804v.924h-.984c-.608 0-1.064-.14-1.368-.42-.304-.28-.456-.74-.456-1.38V9.136h-.852v-.9h.852V6.58h1.092v1.656h1.716v.9h-1.716Zm2.331 2.364c0-.672.136-1.26.408-1.764a2.964 2.964 0 0 1 1.116-1.188 3.11 3.11 0 0 1 1.596-.42c.576 0 1.076.124 1.5.372.424.248.74.56.948.936v-1.2h1.104v6.576h-1.104v-1.224c-.216.384-.54.704-.972.96-.424.248-.92.372-1.488.372a2.98 2.98 0 0 1-1.584-.432 3.03 3.03 0 0 1-1.116-1.212c-.272-.52-.408-1.112-.408-1.776Zm5.568.012c0-.496-.1-.928-.3-1.296a2.065 2.065 0 0 0-.816-.84 2.14 2.14 0 0 0-1.116-.3c-.408 0-.78.096-1.116.288a2.09 2.09 0 0 0-.804.84c-.2.368-.3.8-.3 1.296 0 .504.1.944.3 1.32.2.368.468.652.804.852a2.21 2.21 0 0 0 1.116.288c.408 0 .78-.096 1.116-.288.344-.2.616-.484.816-.852.2-.376.3-.812.3-1.308Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "zeta_watermark_room_svg__a",
    width: 71,
    height: 52,
    x: -16,
    y: -15.188,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14983_69027"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_14983_69027",
    result: "shape"
  })))));
});
SvgZetaWatermarkRoom.displayName = "SvgZetaWatermarkRoom";
export default SvgZetaWatermarkRoom;